/**
 * ============================================================================
 * СЕРВИС ПРОГРЕССА
 * ============================================================================
 * Методы для работы с прогрессом студентов
 * ============================================================================
 */

import api from './api'

export const progressService = {
	/**
	 * Получить прогресс студента по курсу
	 */
	async getCourseProgress(courseId, studentId = null) {
		const url = studentId
			? `/progress/courses/${courseId}?studentId=${studentId}`
			: `/progress/courses/${courseId}`
		const response = await api.get(url)
		return response.data
	},

	/**
	 * Получить прогресс по модулю
	 */
	async getModuleProgress(moduleId, studentId = null) {
		const url = studentId
			? `/progress/modules/${moduleId}?studentId=${studentId}`
			: `/progress/modules/${moduleId}`
		const response = await api.get(url)
		return response.data
	},

	/**
	 * Update module time.
	 */
	async updateModuleTime(moduleId, payload) {
		const response = await api.post(`/progress/modules/${moduleId}/time`, payload)
		return response.data
	},


	/**
	 * Получить прогресс по уроку
	 */
	async getLessonProgress(lessonId, studentId = null) {
		const url = studentId
			? `/progress/lessons/${lessonId}?studentId=${studentId}`
			: `/progress/lessons/${lessonId}`
		const response = await api.get(url)
		return response.data
	},

	/**
	 * Обновить время просмотра и позицию урока.
	 */
	async updateLessonProgress(lessonId, payload) {
		const response = await api.post(`/progress/lessons/${lessonId}/progress`, payload)
		return response.data
	},

	/**
	 * Получить общую статистику студента
	 */
	async getStudentStats(studentId = null) {
		const url = studentId
			? `/progress/statistics?studentId=${studentId}`
			: '/progress/statistics'
		const response = await api.get(url)
		return response.data
	},

	/**
	 * Get student grades grouped by course.
	 */
	async getStudentGrades(studentId = null) {
		const url = studentId ? `/progress/grades?studentId=${studentId}` : '/progress/grades'
		const response = await api.get(url)
		return response.data
	},

	/**
	 * Получить статистику курса (для преподавателя)
	 */
	async getCourseStats(courseId) {
		const response = await api.get(`/progress/courses/${courseId}/statistics`)
		return response.data
	},

	/**
	 * Получить список студентов с прогрессом
	 */
	async getCourseStudentsProgress(courseId) {
		const response = await api.get(`/progress/courses/${courseId}/students`)
		return response.data
	},

	/**
	 * Отметить урок как просмотренный
	 */
	async markLessonComplete(lessonId) {
		const response = await api.post(`/progress/lessons/${lessonId}/complete`)
		return response.data
	},

	/**
	 * Отметить модуль как завершенный
	 */
	async markModuleComplete(moduleId) {
		const response = await api.post(`/progress/modules/${moduleId}/complete`)
		return response.data
	},
}

export default progressService
